import React from "react";
import { FEATURE_KEYS } from "features/Account/Account.constants";
import {
  LICENSE_TYPES,
  LICENSE_TYPE_LABELS,
} from "features/MySubscriptions/constants/MySubscriptions.constants";
import { useOpenAccessTypePurchaseModal } from "features/MySubscriptions/hooks/useOpenAccessTypePurchaseModal";
import { Button } from "@material-ui/core";
import { ReactComponent as AutoFixHigh } from "assets/vectors/autoFixHigh.svg";
import { useWhitelabelFeatures } from "../WhitelabelFeatures/useWhitelabelFeatures";

export const WhitelabelLockCta = ({ onClose }) => {
  const { fetchWhitelabelFeatures } = useWhitelabelFeatures();
  const { openAccessTypePurchaseModal, isOpeningAccessTypePlans } =
    useOpenAccessTypePurchaseModal(FEATURE_KEYS.whitelabel, {
      modalTitle: LICENSE_TYPE_LABELS[LICENSE_TYPES.EXLY_WHITE_LABELLING],
      onSuccess: onClose,
    });

  const ctaText = isOpeningAccessTypePlans ? "..." : "Choose plan";

  const handleClick = async (e) => {
    await fetchWhitelabelFeatures();
    await openAccessTypePurchaseModal(e);
  };

  return (
    <Button
      onClick={handleClick}
      fullWidth
      className="tw-bg-[linear-gradient(212.58deg,#7365cd_14.79%,#40329a_98.64%)] !tw-text-white tw-min-h-[42px] !tw-normal-case"
    >
      <AutoFixHigh className="tw-mr-1 [filter:brightness(0)_invert(1)] tw-h-[13.5px]" />
      <strong className="tw-text-base">{ctaText}</strong>
    </Button>
  );
};
